// Import necessary libraries and components
import './App.css';
import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import Home from './components/pages/Home/Home';
import Dashboard from './components/pages/Dashboard/Dashboard';
import Coin from './components/pages/Coin/Coin';
import { Compare } from './components/pages/Compare/Compare';
import Starred from './components/pages/Starred/Starred';
import { fetchCoins } from './services/fetchCoins';
import { useDispatch } from "react-redux";
import NotFound from './components/pages/NotFound/NotFound';

// Main App component
function App() {
  const dispatch = useDispatch();

  // useEffect hook to dispatch the fetchCoins action when the component mounts
  useEffect(() => {
    dispatch(fetchCoins());
  }, [dispatch]);

  // Return the JSX for the App component
  return (
    <div>
      {/* React Router's Routes component for declarative routing */}
      <Routes>
        {/* Route for the home page */}
        <Route path="/" element={<Home />} />

        {/* Route for displaying cryptocurrency coins */}
        <Route path="/coins" element={<Dashboard />} />

        {/* Route for displaying details of a specific coin */}
        <Route path="/coin/:id" element={<Coin />} />

        {/* Route for comparing two cryptocurrencies */}
        <Route path="/compare" element={<Compare />} />

        {/* Route for displaying starred cryptocurrencies */}
        <Route path="/starred" element={<Starred />} />

        {/* Route for handling any other paths (404 Not Found) */}
        <Route path="/*" element={<NotFound />} />
      </Routes>
    </div>
  );
}

// Export the App component as the default export
export default App;
